const lang = {
    ja: {
        'productManagement.confirmDeleteMessage': 'この商品を削除しますか？',
        'productManagement.noData': '商品がありません。',
        'productManagement.pageTitle': '展示商品管理',
        'productManagement.imageTitle': '画像タイトル：12文字×2行',
        'productManagement.productDescription': '商品説明テキスト：商品ごとに登録する',
        'productManagement.upToSheet': '枚まで',
        'productManagement.upToItem': '件まで',
        'productManagement.totalImageSound': '画像・音声トータル',
        'productManagement.item_suffix': '件',
        'productManagement.totalImageSoundNote': '（例えば、トータルが5件の場合、音声1件使うと、画像展示は4件となります）',
    },
    en: {
        'productManagement.confirmDeleteMessage': '',
        'productManagement.noData': 'There is no matching product.',
        'productManagement.pageTitle': '',
        'productManagement.imageTitle': '',
        'productManagement.productDescription': '',
        'productManagement.upToSheet': '',
        'productManagement.upToItem': '',
        'productManagement.totalImageSound': '',
        'productManagement.item_suffix': '',
        'productManagement.totalImageSoundNote': '',
    },
};

export default lang;
